import * as types from "../actionTypes";

export function setLoadingSuccess(payload) {
	//console.log(payload);
	return { type: types.SET_LOADING, payload };
}
